import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueClipboard from 'vue-clipboard2';
import ElementUI from "element-ui";
import { kyLinSSORun } from './api/login/index';
import elTableInfiniteScroll from 'el-table-infinite-scroll';
import locale from "element-ui/lib/locale/lang/zh-CN"; // 设置语言
import VueTinymce from '@packy-tang/vue-tinymce'; //引入vue-tinymce富文本
import XMonitorWeb from '@xsyx/x-monitor-web'; //项目入口处,如main.js 引入
import JsonViewer from 'vue-json-viewer'

import './plugins/tinymce';// 引入tinymce富文本
import './plugins/echarts'; // 引入echarts图表
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/display.css"; // css响应隐藏类
import './styles/index.scss'; // 引入系统样式

console.log('VueTinymce', VueTinymce);
// 挂载到Vue实例上
Vue.use(VueTinymce)
Vue.use(ElementUI, { locale, size: "small" });
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.use(elTableInfiniteScroll);
Vue.use(JsonViewer)

// 调用，尽量在靠前的位置，可以捕获更多的错误
try {
    let XMonitorWebObject = new XMonitorWeb({
        key: window.g_config.key,//棱镜的平台的key
        url: window.g_config.url,//错误上报的URL，参照下方
        performanceUrl: window.g_config.performanceUrl,//错误上报的URL，参照下方
        eventUrl: window.g_config.eventUrl,//自定义事件上报的URL，参照下方
        //后端的返回，根据返回的状态码来上报错误 回调函数 return true 表示上报错误
        sentry (response) {
            try {
                if (typeof response === 'string') {
                    response = JSON.parse(response);
                }
                if (response.rspCode !== 'success' && response.success === false) {
                    if (response.data && response.data.code === '404') {
                        return false;
                    }
                    return true;
                }
            } catch (e) {
            }
            return false;
        },
    });
    // 如果是vue的页面，通过vue router 配合来监控vue 页面的性能指标，传统的多页面，不用写下面的代码来统计性能
    router.afterEach((to, from) => {
        XMonitorWebObject.performanceVueStart({
            Vue,
            to,
            from,
        });
    });
} catch (e) {
    console.log('棱镜连接发生了故障~', e);
}


// 实例化一个Vue对象
const v = new Vue();
// 路由守卫
router.beforeEach((to, form, next) => {
    let defaultNext = true; // 默认放行
    // 暂且只有一个白名单路由 未抽离直接写死
    if (/^\/htmlPage/.test(to.path)) {
        next()
    } else {
        // 获取用户token
        const token = $kylinOidcAuth.oidcAuthToken;
        // 判断token是否存在
        if (!token) {
            // 跳转到登录页
            kyLinSSORun(async () => {
                // 获取用户信息 存储到store里面
                await store.dispatch('user/getUserInfo');
                await store.dispatch('user/getMySetting');
            });
        } else {
            // 如是从编辑页面跳转 进行保存判断 默认是不放行
            if (form.name === 'addStaticPage' && !store.getters.isSave) {
                defaultNext = false;
                v.$confirm('您有已编辑的文档未保存,是否放弃?', '保存提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    next();
                }
                ).catch(err => {
                    next(false);
                })
            } else {
                // 放行
                next();
            }
        }
    }
    if (defaultNext) next();
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')